import { 
  createIcons, 
  TabletSmartphone, 
  QrCode, 
  MessageCircle, 
  TrendingUp, 
  Sparkles, 
  Zap,
  LayoutGrid,
  Star,
  MapPin,
  Utensils,
  Coffee,
  Wine,
  Sandwich,
  Package,
  Store,
  CircleCheck,
  MessageSquare,
  FileText,
  CheckCircle,
  Palette,
  Eye,
  Send,
  ChevronLeft,
  ChevronRight,
  User,
  Phone,
  Instagram,
  Facebook,
  Youtube,
  MoreHorizontal,
  ArrowUpRight
} from 'lucide';

import { initNavbar } from './sections/nav';
import { initReveal } from './sections/reveal';
import { initMarket } from './sections/market';
import { initGallery } from './sections/gallery';
import { initCounters } from './sections/counters';
import { initFunnel } from './sections/funnel';
import { initContact } from './sections/contact';
import { initObjectives } from './sections/objectives';
import { initMenuComparison } from './sections/menuComparison';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Initialize core components once DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // 1. Initialize Navbar logic
  initNavbar();

  // 2. Render Lucide Icons (Modular imports for optimal bundle size)
  createIcons({
    icons: {
      TabletSmartphone,
      QrCode,
      MessageCircle,
      TrendingUp,
      Sparkles,
      Zap,
      LayoutGrid,
      Star,
      MapPin,
      Utensils,
      Coffee,
      Wine,
      Sandwich,
      Package,
      Store,
      CircleCheck,
      MessageSquare,
      FileText,
      CheckCircle,
      Palette,
      Eye,
      Send,
      ChevronLeft,
      ChevronRight,
      User,
      Phone,
      Instagram,
      Facebook,
      Youtube,
      MoreHorizontal,
      ArrowUpRight
    }
  });

  // 3. Initialize GSAP ScrollTrigger Animations
  initReveal();

  // 4. Initialize Market Carousel (Swiper) & Animations
  initMarket();

  // 5. Initialize Gallery 3D Coverflow Carousel & Animations
  initGallery();

  // 6. Initialize Stats Counters Animations
  initCounters();

  // 7. Initialize Pinned Horizontal Funnel & Animations
  initFunnel();
  
  // 8. Initialize Contact Form Submission & Validation
  initContact();

  // 9. Initialize Objectives (Por qué existimos) interactive cards
  initObjectives();
  initMenuComparison();
  
  console.log('GastroClick base application initialized successfully.');

  // Refresh ScrollTrigger once everything is loaded (CSS, fonts, layouts)
  window.addEventListener('load', () => {
    ScrollTrigger.refresh();
  });
});
